import { Controller } from "@hotwired/stimulus";

// GO4TEACH « Retrouver mes écoles » (2026-10-27), step « Conflits »: « Tout prendre de l'école »
// ticks the school's side of every conflict; the teacher can still change one before going on.
export default class extends Controller {
  allSchool(event) {
    event.preventDefault();
    this.element.querySelectorAll('input[type="radio"][value="school"]').forEach((input) => {
      input.checked = true;
    });
  }
}
